import { AfterViewInit, ElementRef, OnDestroy, OnInit, QueryList } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { ChatPanelService } from 'app/layout/components/chat-panel/chat-panel.service';
var ChatPanelComponent = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param {ChatPanelService} _chatPanelService
     * @param {HttpClient} _httpClient
     * @param {FuseSidebarService} _fuseSidebarService
     */
    function ChatPanelComponent(_chatPanelService, _httpClient, _fuseSidebarService) {
        this._chatPanelService = _chatPanelService;
        this._httpClient = _httpClient;
        this._fuseSidebarService = _fuseSidebarService;
        // Set the defaults
        this.selectedContact = null;
        this.sidebarFolded = true;
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }
    Object.defineProperty(ChatPanelComponent.prototype, "replyForm", {
        set: function (content) {
            this._replyForm = content;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChatPanelComponent.prototype, "replyInput", {
        set: function (content) {
            this._replyInput = content;
        },
        enumerable: true,
        configurable: true
    });
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    /**
     * On init
     */
    ChatPanelComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Load the contacts
        this._chatPanelService.loadContacts().then(function () {
            _this.contacts = _this._chatPanelService.contacts;
            _this.user = _this._chatPanelService.user;
        });
        // Subscribe to the foldedChanged observable
        this._fuseSidebarService.getSidebar('chatPanel').foldedChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (folded) {
            _this.sidebarFolded = folded;
        });
    };
    /**
     * After view init
     */
    ChatPanelComponent.prototype.ngAfterViewInit = function () {
        this._chatViewScrollbar = this._fusePerfectScrollbarDirectives.find(function (directive) {
            return directive.elementRef.nativeElement.id === 'messages';
        });
    };
    /**
     * On destroy
     */
    ChatPanelComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Prepare the chat for the replies
     */
    ChatPanelComponent.prototype._prepareChatForReplies = function () {
        var _this = this;
        setTimeout(function () {
            // Reset the reply form
            _this._replyForm.reset();
            // Focus to the reply input
            // this._replyInput.nativeElement.focus();
            // Scroll to the bottom of the messages list
            if (_this._chatViewScrollbar) {
                _this._chatViewScrollbar.update();
                setTimeout(function () {
                    _this._chatViewScrollbar.scrollToBottom(0);
                });
            }
        });
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Fold the temporarily unfolded sidebar back
     */
    ChatPanelComponent.prototype.foldSidebarTemporarily = function () {
        this._fuseSidebarService.getSidebar('chatPanel').foldTemporarily();
    };
    /**
     * Unfold the sidebar temporarily
     */
    ChatPanelComponent.prototype.unfoldSidebarTemporarily = function () {
        this._fuseSidebarService.getSidebar('chatPanel').unfoldTemporarily();
    };
    /**
     * Toggle sidebar opened status
     */
    ChatPanelComponent.prototype.toggleSidebarOpen = function () {
        this._fuseSidebarService.getSidebar('chatPanel').toggleOpen();
    };
    /**
     * Decide whether to show or not the contact's avatar in the message row
     *
     * @param message
     * @param i
     * @returns {boolean}
     */
    ChatPanelComponent.prototype.shouldShowContactAvatar = function (message, i) {
        return (message.who === this.selectedContact.id &&
            ((this.chat.dialog[i + 1] && this.chat.dialog[i + 1].who !== this.selectedContact.id) || !this.chat.dialog[i + 1]));
    };
    /**
     * Check if the given message is the first message of a group
     *
     * @param message
     * @param i
     * @returns {boolean}
     */
    ChatPanelComponent.prototype.isFirstMessageOfGroup = function (message, i) {
        return (i === 0 || this.chat.dialog[i - 1] && this.chat.dialog[i - 1].who !== message.who);
    };
    /**
     * Check if the given message is the last message of a group
     *
     * @param message
     * @param i
     * @returns {boolean}
     */
    ChatPanelComponent.prototype.isLastMessageOfGroup = function (message, i) {
        return (i === this.chat.dialog.length - 1 || this.chat.dialog[i + 1] && this.chat.dialog[i + 1].who !== message.who);
    };
    /**
     * Toggle chat with the contact
     *
     * @param contact
     */
    ChatPanelComponent.prototype.toggleChat = function (contact) {
        var _this = this;
        // If the contact equals to the selectedContact,
        // that means we will deselect the contact and
        // unload the chat
        if (this.selectedContact && contact.id === this.selectedContact.id) {
            // Reset
            this.resetChat();
        }
        // Otherwise, we will select the contact, open
        // the sidebar and start the chat
        else {
            // Unfold the sidebar temporarily
            this.unfoldSidebarTemporarily();
            // Set the selected contact
            this.selectedContact = contact;
            // Load the chat
            this._chatPanelService.getChat(contact.id).then(function (chat) {
                // Set the chat
                _this.chat = chat;
                // Prepare the chat for the replies
                _this._prepareChatForReplies();
            });
        }
    };
    /**
     * Remove the selected contact and unload the chat
     */
    ChatPanelComponent.prototype.resetChat = function () {
        // Set the selected contact as null
        this.selectedContact = null;
        // Set the chat as null
        this.chat = null;
    };
    /**
     * Reply
     */
    ChatPanelComponent.prototype.reply = function (event) {
        var _this = this;
        event.preventDefault();
        if (!this._replyForm.form.value.message) {
            return;
        }
        // Message
        var message = {
            who: this.user.id,
            message: this._replyForm.form.value.message,
            time: new Date().toISOString()
        };
        // Add the message to the chat
        this.chat.dialog.push(message);
        // Update the server
        this._chatPanelService.updateChat(this.chat.id, this.chat.dialog).then(function (response) {
            // Prepare the chat for the replies
            _this._prepareChatForReplies();
        });
    };
    return ChatPanelComponent;
}());
export { ChatPanelComponent };
